import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-info-dialog-service-unavailable',
    templateUrl: './dialog-info-service-unavailable.component.html',
    styleUrls: ['./dialog-info-service-unavailable.component.scss'],
    imports: [
        MatButtonModule,
        MatIconModule
    ]
})
export class DialogInfoServiceUnavailableComponent {
    public helpUrl = 'https://pomoc.onetads.pl/docs/ograniczenia-dostepu';

    public mailto = 'bok@onetads.pl';
}
